// Compra sin fricción: agregar por AJAX, comprar ahora directo al checkout,
// galería de la ficha y el aviso rotativo con datos verdaderos de la tienda.
(function(){
  var form = document.getElementById('formProducto');

  function idVariante(){
    var campo = form && form.querySelector('[name="id"]');
    return campo ? campo.value : null;
  }

  function pintarContador(carrito){
    document.querySelectorAll('[data-carrito-cuenta]').forEach(function(el){
      el.textContent = carrito.item_count;
      el.hidden = carrito.item_count === 0;
    });
  }

  function actualizarContador(){
    fetch('/cart.js').then(function(r){ return r.json() }).then(pintarContador);
  }

  // ── carrito desplegable ─────────────────────────────
  var drawer = document.getElementById('drawerCarrito');

  function dinero(centavos){
    var formato = drawer && drawer.dataset.money || 'S/. {{amount}}';
    var monto = (centavos / 100).toFixed(2);
    return formato.replace(/\{\{\s*amount[^}]*\}\}/, monto);
  }

  function pintarDrawer(carrito){
    if(!drawer){ return }
    pintarContador(carrito);
    var hay = carrito.item_count > 0;
    drawer.querySelector('[data-drawer-cuenta]').textContent = hay ? '· ' + carrito.item_count : '';
    drawer.querySelector('[data-drawer-vacio]').hidden = hay;
    drawer.querySelector('[data-drawer-pie]').hidden = !hay;
    drawer.querySelector('[data-drawer-subtotal]').textContent = dinero(carrito.total_price);

    // barra de envío gratis
    var envio = drawer.querySelector('[data-drawer-envio]');
    var umbral = parseInt(drawer.dataset.umbral, 10);
    envio.hidden = !hay;
    if(hay){
      var texto = envio.querySelector('[data-drawer-envio-texto]');
      if(carrito.total_price >= umbral){
        texto.textContent = drawer.dataset.txtLogrado;
      } else {
        texto.textContent = drawer.dataset.txtFalta.replace('%s', dinero(umbral - carrito.total_price));
      }
      envio.querySelector('[data-drawer-barra]').style.width = Math.min(100, carrito.total_price * 100 / umbral) + '%';
    }

    // líneas
    var caja = drawer.querySelector('[data-drawer-lineas]');
    caja.textContent = '';
    carrito.items.forEach(function(item){
      var fila = document.createElement('div');
      fila.className = 'drawer-linea';
      fila.dataset.clave = item.key;
      var img = document.createElement('img');
      img.src = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      img.alt = '';
      img.width = 64; img.height = 64;
      var centro = document.createElement('div');
      var titulo = document.createElement('b');
      titulo.textContent = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '');
      var precio = document.createElement('span');
      precio.className = 'drawer-precio precio';
      precio.textContent = dinero(item.final_price);
      var pasos = document.createElement('div');
      pasos.className = 'drawer-pasos';
      pasos.innerHTML = '<button type="button" data-drawer-menos aria-label="Una unidad menos">&minus;</button><span>' + item.quantity + '</span><button type="button" data-drawer-mas aria-label="Una unidad más">+</button>';
      centro.appendChild(titulo); centro.appendChild(precio); centro.appendChild(pasos);
      var total = document.createElement('span');
      total.className = 'drawer-total precio';
      total.textContent = dinero(item.final_line_price);
      var quitar = document.createElement('button');
      quitar.type = 'button'; quitar.className = 'drawer-quitar';
      quitar.setAttribute('data-drawer-quitar', ''); quitar.setAttribute('aria-label', 'Quitar ' + item.product_title);
      quitar.innerHTML = '&times;';
      fila.appendChild(img); fila.appendChild(centro); fila.appendChild(total); fila.appendChild(quitar);
      caja.appendChild(fila);
    });

    // cross-sell: esconder lo que ya está en el carrito, tope de 3
    var enCarrito = carrito.items.map(function(i){ return i.handle });
    var visibles = 0;
    drawer.querySelectorAll('[data-comple-handle]').forEach(function(it){
      var mostrar = enCarrito.indexOf(it.dataset.compleHandle) === -1 && visibles < 3;
      it.hidden = !mostrar;
      if(mostrar){ visibles++ }
    });
    drawer.querySelector('[data-drawer-comple]').hidden = !hay || visibles === 0;
  }

  function abrirDrawer(){
    if(!drawer){ return }
    fetch('/cart.js').then(function(r){ return r.json() }).then(function(carrito){
      pintarDrawer(carrito);
      drawer.hidden = false;
      setTimeout(function(){ drawer.classList.add('abierto') }, 16);
      drawer.querySelector('.drawer-cerrar').focus();
    });
  }

  function cerrarDrawer(){
    if(!drawer){ return }
    drawer.classList.remove('abierto');
    setTimeout(function(){ drawer.hidden = true }, 350);
  }

  function cambiarLineaDrawer(clave, nueva){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: clave, quantity: nueva})
    }).then(function(r){ return r.json() }).then(function(carrito){
      pintarDrawer(carrito);
      // si la página del carrito está abierta detrás, se sincroniza al cerrar
      paginaCarritoDesfasada = !!document.querySelector('[data-linea]');
    });
  }

  var paginaCarritoDesfasada = false;

  if(drawer){
    document.querySelectorAll('[data-abrir-carrito]').forEach(function(a){
      a.addEventListener('click', function(e){ e.preventDefault(); abrirDrawer() });
    });
    document.getElementById('drawerCerrar').addEventListener('click', function(){
      cerrarDrawer();
      if(paginaCarritoDesfasada){ window.location.reload() }
    });
    drawer.addEventListener('click', function(e){
      if(e.target === drawer){
        cerrarDrawer();
        if(paginaCarritoDesfasada){ window.location.reload() }
        return;
      }
      var fila = e.target.closest('.drawer-linea');
      if(!fila){ return }
      var cuantos = parseInt(fila.querySelector('.drawer-pasos span').textContent, 10);
      if(e.target.closest('[data-drawer-mas]')){ cambiarLineaDrawer(fila.dataset.clave, cuantos + 1) }
      if(e.target.closest('[data-drawer-menos]')){ cambiarLineaDrawer(fila.dataset.clave, Math.max(0, cuantos - 1)) }
      if(e.target.closest('[data-drawer-quitar]')){ cambiarLineaDrawer(fila.dataset.clave, 0) }
    });
    addEventListener('keydown', function(e){
      if(e.key === 'Escape' && !drawer.hidden){
        cerrarDrawer();
        if(paginaCarritoDesfasada){ window.location.reload() }
      }
    });
  }

  function cantidad(){
    var campo = form && form.querySelector('[data-cant]');
    var n = campo ? parseInt(campo.value, 10) : 1;
    return (n >= 1 && n <= 99) ? n : 1;
  }

  if(form){
    // selector de talla: cambia la variante que se compra y su precio
    form.querySelectorAll('[name="talla"]').forEach(function(radio){
      radio.addEventListener('change', function(){
        form.querySelector('[name="id"]').value = radio.value;
        var oferta = document.querySelector('.precio-bloque [data-precio]');
        if(oferta && radio.dataset.precio){ oferta.textContent = radio.dataset.precio }
        var ancla = document.querySelector('.precio-bloque .ancla');
        if(ancla && radio.dataset.ancla){ ancla.textContent = radio.dataset.ancla }
      });
    });

    // selector de cantidad de la ficha
    var cant = form.querySelector('[data-cant]');
    if(cant){
      form.querySelectorAll('[data-cant-mas]').forEach(function(b){ b.addEventListener('click', function(){ cant.value = Math.min(99, cantidad() + 1) }) });
      form.querySelectorAll('[data-cant-menos]').forEach(function(b){ b.addEventListener('click', function(){ cant.value = Math.max(1, cantidad() - 1) }) });
    }

    // agregar al carrito sin recargar; el botón confirma en el mismo lugar
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var boton = form.querySelector('[data-agregar]');
      var original = boton.textContent;
      boton.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: idVariante(), quantity: cantidad()})
      }).then(function(r){
        if(!r.ok){ throw r }
        boton.textContent = boton.dataset.listo || 'Agregado ✓';
        abrirDrawer();
        actualizarContador();
        setTimeout(function(){ boton.textContent = original; boton.disabled = false }, 2200);
      }).catch(function(){
        boton.disabled = false;
        window.location.href = '/cart';
      });
    });

    // comprar ahora: directo al checkout con esta variante y su cantidad
    var directo = document.querySelector('[data-comprar-ahora]');
    if(directo){
      directo.addEventListener('click', function(){
        window.location.href = '/cart/' + idVariante() + ':' + cantidad();
      });
    }
  }

  // complementa tu compra: agregar rápido desde el drawer o la página del carrito
  document.querySelectorAll('[data-agregar-rapido]').forEach(function(b){
    b.addEventListener('click', function(){
      b.disabled = true;
      var enDrawer = !!b.closest('#drawerCarrito');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: parseInt(b.dataset.agregarRapido, 10), quantity: 1})
      }).then(function(){
        if(enDrawer && drawer){
          b.disabled = false;
          fetch('/cart.js').then(function(r){ return r.json() }).then(function(c){
            pintarDrawer(c);
            paginaCarritoDesfasada = !!document.querySelector('[data-linea]');
          });
        } else {
          window.location.reload();
        }
      }).catch(function(){ b.disabled = false });
    });
  });

  // galería de la ficha
  var principal = document.getElementById('galeriaImg');
  if(principal){
    document.querySelectorAll('.galeria-thumbs button').forEach(function(t){
      t.addEventListener('click', function(){
        document.querySelectorAll('.galeria-thumbs button').forEach(function(o){ o.setAttribute('aria-current','false') });
        t.setAttribute('aria-current','true');
        principal.src = t.dataset.src;
        principal.alt = t.dataset.alt;
      });
    });
  }

  // aviso rotativo: solo datos verdaderos (envío gratis, contra entrega)
  var toast = document.getElementById('toastVivo');
  if(toast){
    var items = toast.querySelectorAll('.toast-item'), i = 0, timer;
    var mostrar = function(){
      items.forEach(function(it, k){ it.classList.toggle('on', k === i) });
      toast.classList.add('on');
      timer = setTimeout(function(){
        toast.classList.remove('on');
        i = (i + 1) % items.length;
        timer = setTimeout(mostrar, 2600);
      }, 7000);
    };
    setTimeout(mostrar, 5200);
    document.getElementById('toastX').addEventListener('click', function(){
      clearTimeout(timer);
      toast.classList.remove('on');
      toast.setAttribute('hidden','');
    });
  }

  // popup de campaña: una vez por visita, a los N segundos o al llegar al % de scroll
  var popup = document.getElementById('popup');
  if(popup){
    var exito = popup.querySelector('[data-popup-exito]');
    var yaSalio = false;
    var abrir = function(){
      if(yaSalio){ return }
      if(!exito && sessionStorage.getItem('popupVisto')){ return }
      // en una pestaña de fondo no se abre: rAF está pausado y quedaría una capa
      // invisible bloqueando clics, además de gastar el popup sin que nadie lo vea
      if(document.hidden){
        addEventListener('visibilitychange', function reintentar(){
          if(document.hidden){ return }
          removeEventListener('visibilitychange', reintentar);
          abrir();
        });
        return;
      }
      yaSalio = true;
      popup.hidden = false;
      setTimeout(function(){ popup.classList.add('abierto') }, 16);
      popup.querySelector('.popup-cerrar').focus();
      if(typeof pintarAlAbrir === 'function'){ pintarAlAbrir() }
    };
    var cerrar = function(){
      popup.classList.remove('abierto');
      sessionStorage.setItem('popupVisto', '1');
      setTimeout(function(){ popup.hidden = true }, 350);
    };
    document.getElementById('popupCerrar').addEventListener('click', cerrar);
    popup.addEventListener('click', function(e){ if(e.target === popup){ cerrar() } });
    addEventListener('keydown', function(e){ if(e.key === 'Escape' && !popup.hidden){ cerrar() } });

    // tarjeta de raspar: capa de canvas que se borra al arrastrar y descubre el código
    var caja = popup.querySelector('[data-rasca]');
    var revelar = function(){
      if(!caja || caja.classList.contains('revelado')){ return }
      caja.classList.add('revelado');
      caja.setAttribute('aria-label', caja.querySelector('[data-codigo]').textContent);
    };
    if(caja){
      var tapa = caja.querySelector('[data-tapa]');
      var ctx = tapa.getContext('2d', {willReadFrequently: true});
      var pintada = false;
      var pintar = function(){
        var r = caja.getBoundingClientRect();
        if(!r.width || !r.height){ return }
        var dpr = Math.min(devicePixelRatio || 1, 2);
        tapa.width = r.width * dpr;
        tapa.height = r.height * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var g = ctx.createLinearGradient(0, 0, r.width, r.height);
        g.addColorStop(0, '#CBA55C');
        g.addColorStop(.5, '#B08D3C');
        g.addColorStop(1, '#D9BE86');
        ctx.globalCompositeOperation = 'source-over';
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, r.width, r.height);
        ctx.fillStyle = 'rgba(255,255,255,.92)';
        ctx.textAlign = 'center';
        ctx.font = '600 15px "Instrument Sans", system-ui, sans-serif';
        ctx.fillText((tapa.dataset.texto || '').toUpperCase(), r.width / 2, r.height / 2 - 2);
        ctx.font = '450 13px "Instrument Sans", system-ui, sans-serif';
        ctx.fillStyle = 'rgba(255,255,255,.75)';
        ctx.fillText(tapa.dataset.nota || '', r.width / 2, r.height / 2 + 20);
        pintada = true;
      };
      var ultimo = null;
      var borrar = function(e){
        var r = tapa.getBoundingClientRect();
        var x = e.clientX - r.left, y = e.clientY - r.top;
        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath();
        ctx.arc(x, y, 24, 0, Math.PI * 2);
        ctx.fill();
        // el trazo se une con el punto anterior: un arrastre rápido borra una franja
        // continua y no una fila de puntos sueltos
        if(ultimo){
          ctx.lineWidth = 48;
          ctx.lineCap = 'round';
          ctx.lineJoin = 'round';
          ctx.beginPath();
          ctx.moveTo(ultimo[0], ultimo[1]);
          ctx.lineTo(x, y);
          ctx.stroke();
        }
        ultimo = [x, y];
      };
      var limpio = function(){
        var d = ctx.getImageData(0, 0, tapa.width, tapa.height).data;
        var vacios = 0, total = 0;
        for(var i = 3; i < d.length; i += 4 * 64){ total++; if(d[i] < 24){ vacios++ } }
        return total ? vacios / total : 0;
      };
      var rascando = false;
      caja.addEventListener('pointerdown', function(e){
        if(caja.classList.contains('revelado')){ return }
        rascando = true;
        ultimo = null;
        try{ caja.setPointerCapture(e.pointerId) }catch(err){}
        borrar(e);
      });
      caja.addEventListener('pointermove', function(e){ if(rascando){ borrar(e) } });
      var soltar = function(){
        if(!rascando){ return }
        rascando = false;
        ultimo = null;
        if(limpio() > .42){ revelar() }
      };
      caja.addEventListener('pointerup', soltar);
      caja.addEventListener('pointercancel', soltar);
      caja.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); revelar() }
      });
      // la tapa se pinta en cuanto la caja tiene medidas, sin importar cómo se abrió
      // el popup (timer, scroll, vuelta del POST o vista previa del editor)
      if(self.ResizeObserver){
        new ResizeObserver(function(){
          if(caja.classList.contains('revelado')){ return }
          var r = caja.getBoundingClientRect();
          if(r.width && r.height && (!pintada || tapa.width !== Math.round(r.width * Math.min(devicePixelRatio || 1, 2)))){ pintar() }
        }).observe(caja);
      }
      addEventListener('resize', function(){ if(pintada && !caja.classList.contains('revelado')){ pintar() } });
      var pintarAlAbrir = pintar;
    }

    // suscripción: envío nativo de Shopify. Un POST por fetch o a un iframe lo rechaza
    // con "Missing CAPTCHA token", así que el formulario se manda como siempre y la
    // página vuelve con el código a la vista. El raspado ya ocurrió sin tocar la red.
    var formulario = popup.querySelector('form');
    if(formulario){
      formulario.addEventListener('submit', function(){
        if(!formulario.checkValidity()){ return }
        revelar();
        var boton = formulario.querySelector('button[type=submit]');
        if(!boton){ return }
        var textoBoton = boton.textContent;
        boton.disabled = true;
        boton.textContent = 'Enviando...';
        // si el envío se queda a medias, el botón vuelve en vez de quedar muerto
        setTimeout(function(){
          if(!boton.disabled){ return }
          boton.disabled = false;
          boton.textContent = textoBoton;
        }, 12000);
      });
    }

    if(exito){
      // vuelve del POST de Shopify: el popup se abre solo para mostrar el código
      abrir();
    } else {
      var segundos = parseInt(popup.dataset.segundos, 10);
      if(segundos >= 0){ setTimeout(abrir, segundos * 1000) }
      var porScroll = function(){
        var alto = document.body.scrollHeight - innerHeight;
        var pct = parseInt(popup.dataset.scroll, 10) || 50;
        if(alto > 0 && (scrollY / alto) * 100 >= pct){ abrir() }
      };
      addEventListener('scroll', porScroll, {passive: true});
    }
  }

  // cantidad y quitar en el carrito
  document.querySelectorAll('[data-linea]').forEach(function(linea){
    var clave = linea.dataset.linea;
    var cambiar = function(cantidad){
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: clave, quantity: cantidad})
      }).then(function(){ window.location.reload() });
    };
    var input = linea.querySelector('[data-cantidad]');
    linea.querySelectorAll('[data-mas]').forEach(function(b){ b.addEventListener('click', function(){ cambiar(parseInt(input.value,10)+1) }) });
    linea.querySelectorAll('[data-menos]').forEach(function(b){ b.addEventListener('click', function(){ cambiar(Math.max(0,parseInt(input.value,10)-1)) }) });
    linea.querySelectorAll('[data-quitar]').forEach(function(b){ b.addEventListener('click', function(){ cambiar(0) }) });
  });
})();
